import { JSX } from 'react';

import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import BasicDialog from '@zenbusiness/zui/BasicDialog';

/**
 * ResumeModal component renders a dialog with resume and restart actions.
 *
 * @param {object} props - The component's props.
 * @param {boolean} [props.open=false] - Controls the visibility of the modal.
 * @param {Function} [props.onResume] - The function to call when the resume action is triggered.
 * @param {Function} [props.onRestart] - The function to call when the restart action is triggered.
 *
 * @returns {JSX.Element} - A BasicDialog with flow resume and restart actions.
 */
const ResumeModal = ({ open = false, onResume = () => {}, onRestart = () => {} }) => {
  const { formatMessage } = useIntl();

  return (
    <BasicDialog
      open={open}
      primaryAction={{
        label: formatMessage({ id: 'shopping.component.resumeModal.primaryAction' }),
        onClick: onResume,
        clickstreamProps: { elementName: 'resume_modal_primary_action' },
        'data-testid': 'resume-modal-primary-action'
      }}
      secondaryAction={{
        label: formatMessage({
          id: 'shopping.component.resumeModal.secondaryAction'
        }),
        onClick: onRestart,
        clickstreamProps: { elementName: 'resume_modal_secondary_action' },
        'data-testid': 'resume-modal-secondary-action'
      }}
      subtitle={formatMessage({ id: 'shopping.component.resumeModal.subtitle' })}
      title={formatMessage({ id: 'shopping.component.resumeModal.title' })}
    />
  );
};

ResumeModal.propTypes = {
  open: PropTypes.bool,
  onResume: PropTypes.func,
  onRestart: PropTypes.func
};

export default ResumeModal;
